import moment from 'moment'
import convert from 'shared/units/convert'

import {
  METERS,
  IMPERIAL,
  MILES,
  KILOMETERS,
  METERS_PER_SECOND,
  KILOMETERS_PER_HOUR,
  MILES_PER_HOUR,
  SECOND_MI,
  SECOND_KM,
  KILOCALORIES,
  JOULES,
} from 'shared/units/constants'

export const SWIM_ACTIVITY_REGEX = /swim/i

export const NON_DISTANCE_ACITIVITES = [
  'body',
  'gym',
  'strength',
  'weight',
  'workout',
  'bench',
  'calf',
  'knee',
]

export const CYCLING_ACTIVITIES = [
  'bike',
  'cycling',
  'bmx',
]

export function isSwimActivity (activity) {
  if (!activity || !activity.name) { return null }
  return !!SWIM_ACTIVITY_REGEX.test(activity.name)
}

export function isDistanceActivity (activity) {
  if (!activity || !activity.name) { return null }
  return !NON_DISTANCE_ACITIVITES.find(name => (new RegExp(name, 'i')).test(activity.name))
}

export function isCyclingActivity (activity) {
  if (!activity || !activity.name) { return null }
  return !!CYCLING_ACTIVITIES.find(name => (new RegExp(name, 'i')).test(activity.name))
}

export function isSpeedActivity (activity) {
  return isCyclingActivity(activity)
}

export function isPaceActivity (activity) {
  return isDistanceActivity(activity) && !isCyclingActivity(activity)
}

export function isStepsActivity (activity) {
  return isDistanceActivity(activity) && !isSwimActivity(activity) && !isCyclingActivity(activity)
}

export function isRoutableActivity (activity) {
  return isDistanceActivity(activity) && !isSwimActivity(activity)
}

export function calcStartDateTime (startDate, startTime) {
  const date = startDate || moment()
  const time = startTime || moment()

  return date.clone()
    .second(time.second())
    .minute(time.minute())
    .hour(time.hour())
    .format()
}

export function calcDuration ({ hh, mm, ss } = {}) {
  if (hh || mm || ss) {
    return moment.duration(0)
      .add(parseInt(hh, 10) || 0, 'hour')
      .add(parseInt(mm, 10) || 0, 'minute')
      .add(parseInt(ss, 10) || 0, 'second')
      .asSeconds()
  }
}

export function calcDistance (distance, system) {
  const _distance = parseFloat(distance)
  if (isNaN(_distance)) { return }
  if (distance && system) {
    return convert(distance)
      .from(system === IMPERIAL ? MILES : KILOMETERS)
      .to(METERS)
  }
}

export function calcSpeed (n, system, pace = false) {
  const _speed = parseFloat(n)
  if (isNaN(_speed)) { return }

  if (pace) {
    return convert(_speed)
      .from(system === IMPERIAL ? SECOND_MI : SECOND_KM)
      .to(METERS_PER_SECOND)
  } else {
    return convert(_speed)
      .from(system === IMPERIAL ? MILES_PER_HOUR : KILOMETERS_PER_HOUR)
      .to(METERS_PER_SECOND)
  }
}

export function calcEnergy (energy, system) {
  const _energy = parseFloat(energy)
  if (isNaN(_energy)) { return }
  if (system) {
    return convert(_energy)
      .from(KILOCALORIES)
      .to(JOULES)
  }
}

export function getSwimDistance ({ poolLength, poolLengthUnit, laps, system }) {
  if (!poolLength || !laps) { return null }
  const _poolLength = parseFloat(poolLength)
  const _laps = parseInt(laps, 10)
  const _distance = _poolLength * _laps
  return convert(_distance)
    .from(poolLengthUnit)
    .to(system === IMPERIAL ? MILES : KILOMETERS)
    .toFixed(3)
}



// WEBPACK FOOTER //
// ./src/services/workouts/helpers.js